export default __webpack_public_path__ + "nine-black-tiles.png";